import { render, staticRenderFns } from "./PershingPrimaryBeneficiaries.vue?vue&type=template&id=60a0adac&scoped=true"
import script from "./PershingPrimaryBeneficiaries.vue?vue&type=script&lang=js"
export * from "./PershingPrimaryBeneficiaries.vue?vue&type=script&lang=js"
import style0 from "./PershingPrimaryBeneficiaries.vue?vue&type=style&index=0&id=60a0adac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a0adac",
  null
  
)

export default component.exports